import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { cn } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import { TChapterInfo } from './pdf.models';

interface IChaptersNavigatorProps {
  chapters: TChapterInfo[];
  handleChapterChange: (chapterNumber: string) => void;
  selectedChapter: TChapterInfo;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
}

function ChaptersNavigator(props: IChaptersNavigatorProps) {
  const { t } = useTranslation();
  const selectedChapterRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (selectedChapterRef.current) {
      selectedChapterRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  return (
    <div className="custom-scroll max-h-[calc(100vh-120px)] overflow-y-auto py-3 px-3">
      <div>
        <div className="flex justify-between items-center gap-6 py-1 min-h-8 font-bold mb-4">
          <p>{t('pdf.chapter')}</p>
          <p>{t('pdf.page')}</p>
        </div>
        <div>
          {props.chapters.map((chapter) => (
            <div
              key={chapter.number}
              ref={props.selectedChapter.number === chapter.number ? selectedChapterRef : null}
              className={cn(
                'flex justify-between items-center gap-6 p-1 px-2 mb-1 min-h-8 border-b-2 border-transparent rounded transition-transform duration-300 cursor-pointer',
                'hover:text-xircle-main hover:border-xircle-main hover:bg-xircle-main-soft/10',
                {
                  // 'pl-4': chapter.number.length > 2,
                  'text-xircle-main border-xircle-main bg-xircle-main-soft/10':
                    props.selectedChapter.number === chapter.number,
                }
              )}
              onClick={() => {
                props.handleChapterChange(chapter.number);
              }}
            >
              <p>
                {chapter.number.length < 6 && chapter.number} {chapter.title}
              </p>
              <p>
                {props.chapters.find((chapterItem) => chapterItem.number === chapter.number)?.page}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ChaptersNavigator;
